// extracted by mini-css-extract-plugin
export default {"carousel_image_container":"SlideImage_carousel_image_container__rSAd2","slide_image":"SlideImage_slide_image__vPY6a"};